export const DobBannerErrorMessageStyles = {
  errorMessage: 'my-4'
}
